import React from 'react'

type Props = {
    // The row's own inset. It stays a class rather than moving into the
    // stylesheet because the task-selector field popover reuses this row with a
    // different one -- a rule under `.gd-entity-selector` would win over it.
    className?  : string
    children?   : any
}

const debug = false
// const debug = "EntitySelectorSearchRow"

// The full-width search line. It sizes to its input rather than to a constant:
// the panes below it are flex children, so nothing downstream has to subtract a
// chrome height any more.
export default function EntitySelectorSearchRow(props:Props) {

    // 15px is the selector's one inset -- the same the sidebar's menu rows and
    // both titles use, so the input's left edge lines up with them.
    const classes = Classes("entity-selector-search flex-row-left-center flex-no-shrink",
                            props.className || "p-l-20 p-r-20 p-b-20")

    return (
        <div className={classes}>
            {props.children}
        </div>
    )
}
